import React from 'react';

const cleanPercentage = (percentage) => {
    const isNegativeOrNaN = !Number.isFinite(+percentage) || percentage < 0; // we can set non-numbers to 0 here
    const isTooHigh = percentage > 100;
    return isNegativeOrNaN ? 0 : isTooHigh ? 100 : +percentage;
};

const Circle = ({ colour, percentage, size }) => {
    const strokeW = .1 * size;
    const r = size/2-strokeW;
    const circ = 2 * Math.PI * r;
    const strokePct = ((100 - percentage) * circ) / 100; // where stroke will start, e.g. from 15% to 100%.
    return (
        <circle
        r={r}
        cx={(size+20)/2}
        cy={(size+20)/2}
        fill="transparent"
        stroke={strokePct !== circ ? colour : ""} // remove colour as 0% sets full circumference
        strokeWidth={strokeW}
        strokeDasharray={circ}
        strokeDashoffset={percentage ? strokePct : 0}
        ></circle>
    );  
};

const CircularProgressbar = ({ percentage, colour, size }) => {
    const pct = cleanPercentage(percentage);
    return (
        <svg width={size+20} height={size+20}>
            <g transform={`rotate(-90 ${(size+20)/2} ${(size+20)/2})`}>
                <Circle colour={"transparent"} size={size} />
                <g className='blur'>
                    <Circle colour={colour} percentage={pct} size={size} />
                </g>
                <Circle colour={colour} percentage={pct} size={size} />
            </g>
        </svg>
    );
};      

export default CircularProgressbar;
